// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/radio/Primary.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { Radio } from '@sail/ui';
export const Primary = () => {
  return <Radio label="This is a Radio." />;
};